var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 478,
    y: 230,
    width: 48,
    height: 48
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-478 -230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M513.805 256.161 515.828 261.04 506.478 261.04C506.441 263.513 504.406 265.488 501.934 265.451 499.513 265.414 497.56 263.461 497.523 261.04L488.165 261.04 492.323 251 499.405 251C498.89 250.058 498.511 249.048 498.278 248L490.318 248 485 260.84 485 272 519 272 519 260.862 516.433 254.668C515.627 255.279 514.743 255.781 513.805 256.161Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.5 236C504.253 236 500 240.253 500 245.5 500 250.747 504.253 255 509.5 255 514.747 255 519 250.747 519 245.5 519.002 240.255 514.753 236.002 509.508 236 509.505 236 509.503 236 509.5 236ZM511.8 245.954C510.416 247.335 509.023 248.729 507.622 250.135 506.432 248.939 505.239 247.746 504.043 246.555L505.239 245.359 507.622 247.743C508.78 246.57 509.93 245.404 511.073 244.247 512.216 243.09 512.849 242.469 514.034 241.322 514.068 241.289 514.103 241.256 514.142 241.223 514.179 241.191 514.213 241.154 514.242 241.115L515.455 242.311C514.05 243.712 513.186 244.572 511.8 245.954Z",
    fill: "#FFFFFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.1056c45b19b14e5637cb04e147b7cf07.svg";
export { ForwardRef as ReactComponent };